<template lang="pug">
  .row
    medication-form(
      v-if="editing"
      :entity_attrs="current_rfb.entity_attrs" :attrs="form_block.attrs" :required-attrs="form_block.required_attrs"
      :usedEntityIds="usedEntityIds"
      @save="onModalSave", @cancel="onModalCancel" :top="true"
    )
    .columns.large-24
      article.content-block.collapse
        header
          .title {{t(`app.programs.edit.form_part.label.${form_part.handle}`, {default: form_part.name})}}
        section.content
          p.small(v-if="isPresent(form_part.description)" v-html="to_br(form_part.description)" v-linkified)
          table
            thead.medication-header
              th(v-for="attr in form_block.attrs", v-html="placeholder(attr)")
              th(v-for="cf in form_block.custom_fields")
                | {{cf.name}}
                span(v-if="form_block.required_custom_field_ids.includes(cf.id)")
                  | ({{t('helpers.label.required').toLowerCase()}})
              th
            tbody
              template(v-for="(rfb, idx) in registrationFormBlocks")
                part-medication(
                  :object="objects.findById(rfb.entity_id)"
                  :form_block="form_block", :rfb="rfb"
                  :key="rfb.id"
                  @change="onChange(rfb, idx, $event)" @delete="destroyRfb(rfb)" v-if="!rfb._destroy"
                )
              tr
                td.new(:colspan="colspan")
                  a.button.new-button.expand(@click.prevent="onModalNew") {{t('app.registration.medication.add_new')}}
</template>
<script>
import helpers from "../../../../code/base_mixins";
import partMedication from '../../form_block/content/_part_medication'
import medicationForm from '../_medication_form'
export default {
  name: "FormPartHeaderMedication",
  components: {medicationForm,partMedication},
  mixins: [helpers],
  props: {
    form_part: {type: Object, required: true},
  },
  data(){
    return{
      editing: false,
      current_rfb: null,
      objects: [],
    }
  },
  computed: {
    registration() { return this.state.current_reg },
    editing_provisioned() {return this.registration.id && this.state.current_org.id && this.registration.owner_type === 'TempUser'},
    form_block(){ return this.form_part.form_blocks[0] },
    colspan(){
      return this.form_block.attrs.length + this.form_block.custom_field_ids.length + 1
    },
    usedEntityIds(){
      const formBlockIds = this.form_part.form_blocks.map((fb)=>fb.id)
      const used_ids = []
      for(let rfb of this.registration.registration_form_blocks){
        if (formBlockIds.includes(rfb.form_block_id) && rfb.entity_attrs.id) used_ids.push(rfb.entity_attrs.id);
      }
      return used_ids
    },
    registrationFormBlocks(){
      const arr = []
      for (const rfb of this.registration.registration_form_blocks){
        if(rfb.form_block_id===this.form_block.id){
          rfb.form_block =  this.form_block
          arr.push(rfb)
        }
      }
      return arr
    },
  },
  watch: {
    "registration.person_id"() {
      if (this.registration.new_person_was) return
      for (let rfb of this.registrationFormBlocks) this.destroyRfb(rfb)
      this.loadData()
    },
  },
  created(){
    this.loadData()
  },
  methods: {
    async loadData(){
      if (this.editing_provisioned){ // ONLY FOR PROVISIONED. A hack. In other cases org shouldn't get access to whole people_medications
        this.objects = this.registration.person.medications
        return
      }
      this.objects = await this.$store.dispatch("reg_store/people_medications") || []
    },
    placeholder(attr){
      let str = this.t(`helpers.placeholder.form_attribute.${this.$sanitize(attr)}`)
      if (this.is_required) str = "<span class='required-text'><span class='required'>*</span> " + str + "</span>"
      return str
    },
    onModalNew(){
      this.current_rfb = this.bindRFB({})
      this.editing = true
    },
    onModalCancel(){
      this.editing = false
    },
    onModalSave(new_obj){
      this.registration.registration_form_blocks.push(this.bindRFB(new_obj))
      this.editing = false
    },
    destroyRfb(rfb){ 
      this.$set(rfb, "_destroy", true)
      rfb.has_changed = true
    },
    onChange(rfb, idx,newObj){
      this.$set(rfb, "entity_id", newObj.id)
      for (let [k,v] of Object.entries(newObj)){
        this.$set(rfb.entity_attrs, k, v)
        this.attrChange(rfb, idx, 'entity_attrs', k, v)
      }
    },
    bindRFB(new_obj){
      return {
        form_block: this.form_block,
        form_block_id: this.form_block.id,
        entity_type: this.form_part.style,
        entity_attrs: new_obj,
        entity_id: -1,
      }
    },
    resetReg(){
      window.$reg ||= {}
      window.$reg.temp_rfb = {}
    },
    attrChange(rfb, idx, group, attr, value){
      if (!value) return
      const rfb_id = rfb.id
      const fb_id  = rfb.form_block_id
      window.$reg.temp_rfb[fb_id] ||= []
      window.$reg.temp_rfb[fb_id][idx] = {
        id: rfb_id, form_block_id: fb_id,
        _destroy: false,
        name: this.form_part.form_blocks[0].name,
        entity_attrs: {}, custom_attrs: {},
        ...window.$reg.temp_rfb[fb_id][idx]
      }
      // setting to antity_attrs or custom_attrs
      window.$reg.temp_rfb[fb_id][idx][group] = {...window.$reg.temp_rfb[fb_id][idx][group], [attr]: value}
      window.$reg.temp_rfb[fb_id][idx].entity_id = this.entity_id
      this.state.current_reg.doTouch()
    },
  },
}
</script>

